import React , {Component} from 'react';
import * as axios from "axios/index";
import {
    Page  , Link
} from 'framework7-react';
import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import EventLoading from "../Loader/EventLoading";
import EventCard from "../Cards/EventCard";

import * as vars from './Vars';

class Events extends Component{



    constructor(props){
        super(props)
        this.state = {


            requestLoading : true ,
            events : [] ,

        }
    }







    componentDidMount(){


        if (localStorage.getItem('logged') === undefined  || localStorage.getItem('logged') === null)
        {
            this.$f7router.navigate('/login-singup/')
            return
        }


        localStorage.removeItem('selectedDelivery' )

        let data = new FormData()
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )
        data.append('add_edit_delete' , "list" )
        axios.post(vars.PreUrl + 'https://www.lavefood.com/v1/event' , data )
            .then(response => {

                let data = response.data.result[0]
                console.log( data.events)
                if(data.error === 0)
                {
                    this.setState({
                        events : data.events ,
                        requestLoading : false ,
                    })
                }
                else
                {

                }




            })
            .catch(error => {
                console.log(error)
            })

    }


    onPageBeforeIn(){
        this.props.toolbar(false)
    }

    render(){

        return(
            <Page name="Event" className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>

                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        رویدادها
                    </div>
                </div>

                <div id="inner-header-separator" />


                {
                    this.state.requestLoading === true ? (
                        <EventLoading  />
                    ): (
                        <div  >

                            {
                                this.state.events.map((object , index) =>
                                    <EventCard object={object} key={index}    />
                                )
                            }



                        </div>
                    )
                }

            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({

    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar ,
        branch : state.branch ,
    }
}

export default connect( mapStateToProps  , mapDispatchToProps)(Events);